import FooterIcon from '../../../../assets/icons/trvto_footerIcon.png';
import { Link } from 'react-router-dom';

const FooterItem = ({ name }) => {
    return (
        <div className='menuItem'>
            <img src={FooterIcon} alt='trvto_arrow' />
            <Link to={name.link}>{name.name}</Link>
        </div>
    );
};

export default FooterItem;
